export class IReportGraph {
  levelEntityName: string;
  levelEntityXtra: string;
  reportMeasureValue: number;
  marketSharePercentage: number;
  isCb?: boolean;
}
